export default __webpack_public_path__ + "static/media/office2hold.a8bcd91c.jpg";